import { render, staticRenderFns } from "./addresstabs.vue?vue&type=template&id=7fc8109a&"
import script from "./addresstabs.vue?vue&type=script&lang=js&"
export * from "./addresstabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports